import React, { useEffect } from 'react';
import { Header } from 'components/common/header/Header';
import './CommonEmbed.css';

// wiz-common-front URL (환경에 따라 설정)
const WIZ_COMMON_URL = process.env.REACT_APP_WIZ_COMMON_URL || 'http://localhost:3010';

interface CommonEmbedProps {
    title: string;
    path: string;
    showHeader?: boolean;
}

export const CommonEmbed: React.FC<CommonEmbedProps> = ({ title, path, showHeader = true }) => {
    useEffect(() => {
        const iframe = document.getElementById('common-iframe') as HTMLIFrameElement;
        if (iframe) {
            iframe.onload = () => {
                // 토큰을 iframe에 전달
                const token = localStorage.getItem('accessToken');
                if (token && iframe.contentWindow) {
                    iframe.contentWindow.postMessage({ type: 'AUTH_TOKEN', token }, WIZ_COMMON_URL);
                }
            };
        }
    }, [path]);

    return (
        <div className="common-embed-wrapper">
            {showHeader && <Header title={title} isSubPage={true} />}
            <div className="common-embed-content">
                <iframe
                    id="common-iframe"
                    src={`${WIZ_COMMON_URL}${path}?popup=true`}
                    title={title}
                    className="common-iframe"
                />
            </div>
        </div>
    );
};
